'use client'
import React from 'react'

const PageClient: React.FC = () => {
  /* Force the header to be dark mode while we have an image behind it */

  return <React.Fragment />
}

export default PageClient
